<template lang="html">
    <div class="row w-100 py-2" :class="{'row-state py-2' : !valid || hasPriceGroupServiceError}">
        <div class="col-sm-3">
            <v-select
                v-if="extras"
                v-model="service.component"
                :class="{'notAllowed':disabled}"
                :options="extras"
                placeholder="- Select category -"
                label="name"
                @input="updateExtra(service, service.component)"
                :disabled="disabled">
            </v-select>
        </div>

        <div class="col-sm-2" v-if="componentRuleType != 1">
            <v-select
                v-if="extras && service.isRemainingValue == false && componentRuleType != 1"
                v-model="service.component.selectedPrice"
                :class="{'notAllowed':disabled}"
                :options="service.component.prices"
                placeholder="- Select category -"
                label="name"
                @input="updateExtraPrice(service, $event)"
                :disabled="disabled">
            </v-select>
        </div>

        <div class="col-sm-2 pt-2" v-if="componentRuleType == 1 || service.isRemainingValue">
            <span>
                {{taxIdToName(service.component.vatType)}}
            </span>
        </div>

        <div class="col-sm-2 pt-2"  v-else>
            <span v-if="service.component.selectedPrice && service.component.selectedPrice.vatType !== undefined">
                {{taxIdToName(service.component.selectedPrice.vatType)}}
            </span>
        </div>

        <div class="col-sm-2" v-if="componentRuleType == 1">
            <div class="d-flex align-items-center">
                <input 
                    type="number" 
                    style="width: 4rem;"
                    :value="service.value || 0"
                    @input="updatePercentValue($event.target.value)"
                    @change="updateValue()"
                    :disabled="disabled"
                /> 
                <div class="ml-2">%</div>
            </div>
        </div>

        <div class="col-sm-2 pt-2" v-if="componentRuleType == 1 && !isPricePerGroup">
            <span v-if="service.component">
                {{pvpBasedOnPercentValue(service.value)}} €
            </span>
        </div>

        <div class="col-sm-2 pt-2" v-if="componentRuleType == 2">
            <input 
                type="checkbox"
                :disabled="localPriceObj.productGenderPriceComponents.length == 1 && !disabled"
                :value="true"
                :name="'isRemaning'"
                :id="'isRemaining-' + index"
                @change="updateIsRemainingValue(service)"
                v-model="service.isRemainingValue"/>
        </div>

        <div class="col-sm-2 pt-2" v-if="componentRuleType != 1 && !service.isRemainingValue">
            <span v-if="service.component.selectedPrice" class="ml-2">
                {{service.component.selectedPrice.grossprice.toFixed(2).replace(".", ",")}} €
            </span>
        </div>

        <div class="col-sm-2" v-if="componentRuleType == 2 && service.isRemainingValue">
            <div class="d-flex align-items-center">
                <input 
                    type="number"
                    class="px-2"
                    style="width: 4.5rem;"
                    disabled
                    :value="updateValueRemainingValueItem(service)"
                /> 
                <div class="ml-2">€</div>
            </div>
        </div>

        <div class="d-flex justify-content-end col pt-2">
            <i class="ico-delete fs-large medium pointer m-0" v-if="!disabled" @click="removePrice(index)"></i>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import extendedVSelect from '@/extends/vue-select'

export default {
    data() {
        return {
            localPriceObj: null,
        }
    },
    props: {
        service: {
            type: Object
        },
        index: {
            type: Number
        },
        disabled: {
            type: Boolean,
            default: false
        },
        isPricePerGroup: {
            type: Boolean,
            default: false
        },
        componentRuleType: {
            type: Number,
            default: false
        },
    },
    created() {
        this.updateRowToStore();
        this.localPriceObj = JSON.parse(JSON.stringify(this.getProductEditPriceData));
    },
    watch: {
        getProductEditPriceData: {
            deep: true,
            handler(newVal) {
                this.localPriceObj = JSON.parse(JSON.stringify(newVal));
            }
        }
    },
    computed: {
        ...mapGetters([
            'getVatTypes',
            'getExtras',
            'getProductEditPriceData'
        ]),
        hasPriceGroupServiceError() {
            return ((this.service.value < 0.1 || !this.service.value) && this.service.isRemainingValue) && !this.isPricePerGroup;
        },
        taxes() {
            return this.getVatTypes;
        },
        extras() {
            return JSON.parse(JSON.stringify(this.getExtras));
        },
        valid() {
            // Valid row to percent type
            if (this.localPriceObj.componentRuleType == 1 ) {
                return this.service.value == null || this.service.value == '' ? false :  true;
            } // Valid row to open type
            else if (this.localPriceObj.componentRuleType == 2) {
                return this.service.component.selectedPrice == null && !this.service.isRemainingValue ?  false  :  true;
            } // Valid row to fixed type
            else if (this.localPriceObj.componentRuleType == 0) {
                return this.service.component.selectedPrice == null ? false  : true;
            }
        }
    },
    methods: {
        updatePercentValue(val) {
            // Converts to number, removing leading zeros automatically
            let numericValue = Number(val);
            this.$set(this.service, 'value', isNaN(numericValue) ? 0 : numericValue);
        },
        updateValue() {
            this.updateRowToStore();
        },
        updateValueRemainingValueItem(service) {
            let total;
            
            if (this.localPriceObj.genderPriceType === 3) {
                total = parseFloat(this.localPriceObj.grossprice);
            } else {
                total = parseFloat(this.localPriceObj.value);
            }
            
            const listOfValuesOfGrossprices = this.localPriceObj.productGenderPriceComponents.map(service => !service.isRemainingValue && service.component.selectedPrice != null ? parseFloat(service.component.selectedPrice.grossprice) : 0);
            const sumGrossprices = listOfValuesOfGrossprices.length > 0 ? listOfValuesOfGrossprices.reduce((accumulator, currentValue) => accumulator + currentValue, 0) : 0;

            // The value of remaining item must be the difference between localPriceObj.value and sumGrossprices
            let valueOfRemainingServiceItem = parseFloat(total-sumGrossprices);
    
            service.value = Number(valueOfRemainingServiceItem.toFixed(2));
            
            return this.isPricePerGroup ? null : valueOfRemainingServiceItem.toFixed(2);
        },
        updateIsRemainingValue(service) {
            // has isRemainingValue == true. We send the index and the new value.
            this.$emit('remaining-selected', this.index, !!service.isRemainingValue);

            this.updateRowToStore();
        },
        pvpBasedOnPercentValue(serviceValue) {
            if (serviceValue !== null) {
                let priceService = (this.localPriceObj.value * serviceValue) / 100;
                
                return (priceService).toFixed(2).replace(".", ",");
            } else {
                return '0,00'
            };
        },
        updateExtra(service, component) {
            if (service.component == null) {
                service.component = JSON.parse(JSON.stringify(this.extras[0]));
            }

            this.localPriceObj.componentRuleType == 1 || service.isRemainingValue ? service.vatType = service.component.vatType : null;
            this.updateRowToStore();
        },
        updateExtraPrice(service, e) {
            if (service.component.selectedPrice == null) {
                service.component.selectedPrice = service.component.prices[0];
                service.value = service.component.prices[0].grossprice;
                service.vatType = service.component.prices[0].vatType;
            } else {
                service.selectedPrice = e;
                service.value = e.value;
                service.vatType = e.vatType;
                this.$emit('this-is-valid-row', true);
            }

            this.updateRowToStore();
        },
        taxIdToName(taxId){
            if (this.taxes) {
                return this.taxes.filter((tax) => {
                    return tax.id == taxId;
                })[0].description;
            }
        },
        removePrice(index) {
            this.$emit('removePrice', index);
        },
        updateRowToStore() {
            this.$emit('change');
        }
    },
    components: {
        vSelect: extendedVSelect,
    }
}
</script>

<style lang="scss" scoped>
    .row-state {
        background-color: #ffe5e5;
    }
</style>



// WEBPACK FOOTER //
// SplitPriceEditorRow.vue?1251a020